import { useState, useEffect } from 'react';
// Our hook
export function useDebounce(values: ReadonlyArray<any>, delay: number) {
  const [debouncedValue, setDebouncedValue] = useState(values);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(values);
    }, delay);
    return () => {
      clearTimeout(handler);
    };
  }, values);
  return debouncedValue;
}
